var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M8.593 4C6.056 4 4 6.067 4 8.617v6.766C4 17.933 6.056 20 8.593 20h6.814C17.944 20 20 17.933 20 15.383V8.617C20 6.067 17.944 4 15.407 4H8.593zM5.48 15.383V8.617A3.12 3.12 0 018.593 5.49h6.814a3.12 3.12 0 013.111 3.128v6.766a3.12 3.12 0 01-3.11 3.127H8.592a3.12 3.12 0 01-3.112-3.127z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M7.81 12.064c0 2.338 1.885 4.234 4.211 4.234 2.326 0 4.212-1.896 4.212-4.234 0-2.339-1.886-4.234-4.212-4.234-2.326 0-4.211 1.895-4.211 4.234zm6.941 0a2.737 2.737 0 01-2.73 2.744 2.737 2.737 0 01-2.73-2.744 2.737 2.737 0 012.73-2.745 2.737 2.737 0 012.73 2.745zm1.524-3.319a1.02 1.02 0 001.016-1.022c0-.564-.455-1.021-1.016-1.021a1.02 1.02 0 00-1.016 1.021 1.02 1.02 0 001.016 1.022z",
    clipRule: "evenodd"
  }));
}
export default SvgIconInstagram;